function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { EmotionCacheProvider, ThemeProvider } from '@ori-ui/mui';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { Suspense } from 'react';
import { Loading } from './components';
import { APP_NAME, EMOTION_CACHE_KEY } from './constants';
import { ApiProvider, ErrorBoundary, Router } from './containers';
import { I18nContainer } from './containers/I18nContainer';
import { ConfigurationProvider, NotificationProvider } from './contexts';
import { FormProvider } from './contexts/FormContext';
export var App = function(param) {
    var configuration = param.configuration, activePath = param.activePath;
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(ConfigurationProvider, {
            value: configuration,
            children: /*#__PURE__*/ _jsx(TestIdProvider, {
                team: Team.Acquisition,
                project: APP_NAME,
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: /*#__PURE__*/ _jsx(Loading, {}),
                    children: /*#__PURE__*/ _jsx(EmotionCacheProvider, {
                        cacheKey: EMOTION_CACHE_KEY,
                        children: /*#__PURE__*/ _jsx(ThemeProvider, {
                            children: /*#__PURE__*/ _jsx(I18nContainer, _object_spread_props(_object_spread({}, configuration), {
                                children: /*#__PURE__*/ _jsx(FormProvider, {
                                    children: /*#__PURE__*/ _jsx(ApiProvider, {
                                        children: /*#__PURE__*/ _jsx(NotificationProvider, {
                                            children: /*#__PURE__*/ _jsx(Router, {
                                                activePath: activePath
                                            })
                                        })
                                    })
                                })
                            }))
                        })
                    })
                })
            })
        })
    });
};
